import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { InstitusionContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";
import { toast } from "react-toastify";

const PurchaseUsdt1 = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.instituson;
  const contract = InstitusionContract(tokenAddress, web3);
  const UsdtAdress=Environment.busd
  const purchaseUsdt1 = useCallback(
    async (amount, postApiRes,id,balance,min,stakeIndex) => {
      amount =parseFloat(amount).toFixed(6)
      let amount1 = Math.round((amount) * 1e12) / 1e12;
      let nd = web3.utils.toWei(amount1.toString(), "mwei");

      let minvalue=min*0.99
      minvalue= parseFloat(minvalue).toFixed(6)
      minvalue=Math.round((minvalue) * 1e12) / 1e12;
      // console.log(minvalue,'minvalue');
      minvalue= web3.utils.toWei(minvalue.toString(), "ether");
  

       console.log( UsdtAdress,nd,postApiRes.code,postApiRes?.normalizationFactor,postApiRes.referenceTokenPrice,id,postApiRes.price,postApiRes.deadline,postApiRes?.v, postApiRes?.r, postApiRes?.s);
  //     let tuple = {
  //       postApiRes.code:postApiRes.postApiRes.code,
  //       GodAgentPercentage:postApiRes.gotAgentPercentage,
  //       MegaAgentPercentage:postApiRes.megaAgentPercentage,
  //       SuperAgentPercentage:postApiRes.superAgentPercentage,
  //       AgentPercentage:postApiRes.agentPercentage,
  //       GodAgentAddress:postApiRes.gotAgentAddress,
  //       MegaAgentAddress:postApiRes.megaAgentAddress,
  //       SuperAgentAddress:postApiRes.superAgentAddress,
  //       AgentAddress:postApiRes.agentAddress,
  // }; 
  let gas
      try {
        let gasPrice=await web3.eth.getGasPrice()
        gasPrice = parseInt(gasPrice) + 3000000000
         gas = await contract.methods
          .purchaseWithToken(
            UsdtAdress,nd,postApiRes.code,postApiRes?.normalizationFactor,postApiRes.referenceTokenPrice,minvalue,id,postApiRes.price,postApiRes.deadline,postApiRes?.v, postApiRes?.r, postApiRes?.s
          )
          .estimateGas({
            from: account,
            gasPrice

          });
        const details = await contract.methods
          .purchaseWithToken(
            UsdtAdress,nd,postApiRes.code,postApiRes?.normalizationFactor,postApiRes.referenceTokenPrice,minvalue,id,postApiRes.price,postApiRes.deadline,postApiRes?.v, postApiRes?.r, postApiRes?.s
          )
          .send({
            from: account,
            gas:gas,
            gasPrice
          });
        return details;
      } catch (error) {
        // let gasPrice1=await web3.eth.getGasPrice()
        // let gasPrice = parseInt(gasPrice1) + 3000000000
        // gas=gas*gasPrice
        // let nd = web3.utils.fromWei(gas.toString(), "ether");
        // console.log(gas,nd,balance );
        // if(nd>balance){
        //    toast.error("Insufficient ETH for Transaction")
        // }else{
          throw error;
        // }
      }
    },
    [contract, account,web3]
  );
  return { purchaseUsdt1: purchaseUsdt1 };
};
export default PurchaseUsdt1;
